export default __webpack_public_path__ + "media/blueHighlight.5a0d6d38dbc916027994bf8f013aab93.svg";